import {ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {FITHParsedGameData} from "../../server/data/FITHParsedGameData";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {FITHGameModuleConfig} from "../../FITHGameModuleConfig";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";
import {FITHGameConfig} from "../../FITHGameConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {FITHAvalancheReelController} from "../../reel/FITHAvalancheReelController";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {FITHGameMode} from "../../gameMode/FITHGameMode";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {FITHSoundManager} from "../../sound/FITHSoundManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {FITHSoundConfig} from "../../FITHSoundConfig";

export class FITHFreeSpinOutroView extends ScreenView {
    private _animation: PIXI.spine.Spine;
    private _container: PIXI.Container;
    private _totalWin: BitmapCountUp;
    private _playedBetValueMultiply: PIXI.Text;
    private _youWonLabel: PIXI.Text;
    private _totalWinLabel: PIXI.Text;
    private _spinsPlayedNumber: PIXI.Text;
    private _blackGfx: PIXI.Graphics;
    private _finallyIFoundIt: PIXI.Sprite;
    private _beerTime: PIXI.spine.Spine;
    private _isBeerTimePlaying: boolean = false;
    private _beerTimeFire: TimelineSprite;

    private _reelsEnteringBonus: string[][] | undefined = [];

    private static actuallyDoTransition(): void {
        FITHGameModuleConfig.background.toggleFSOverlay(false, 0);
        FITHGameModuleConfig.background.exitFS();
        FITHGameModuleConfig.reelBackgroundView.exitFS();
        FITHGameModuleConfig.reelFrameView.exitFS();
        FITHGameModuleConfig.winWaysBoard.exitFS();
        FITHGameModuleConfig.reelAreaView.exitFS();
        FITHGameModuleConfig.bonusGameSpinNWagonAnimations.exitFS();
        FITHGameModuleConfig.wildMultiplierView.exitFS();

        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM; i++) {
            (Reels.getReel(i) as FITHAvalancheReelController).exitFS();
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.exitFS(i);
        }
        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM_ORIGINAL; i++) {
            const startSymId: number = 3;
            for (let j: number = startSymId; j < (FITHGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1); j++) {
                FITHGameModuleConfig.bonusGameVSymbolOverlayView.toggleDOverlaySymbol(i, j, false);
            }
            // #151
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.toggleBottomRowWagon(i, false);
        }

        this.cleanupReels();

        FITHGameModuleConfig.reels.mode = FITHGameMode.NORMAL;
    }

    private static cleanupReels(): void {
        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM; i++) {
            let reel: (StateReelSymbol | null)[] = Reels.allSymbols(i);
            for (let j: number = 0; j < reel.length; j++) {
                reel[j]!.removeChildren();
                reel[j]!.replaceWith("L" + (MathHelper.randomIntInRange(1, 5)), j);
            }
        }
    }

    protected initAnimations(): void {
        this._animation = new PIXI.spine.Spine(GameResources.getSpineAsset("FS_Outro"));
        this._animation.visible = false;
        this.addChild(this._animation);

        super.initAnimations();

        this._blackGfx = new PIXI.Graphics();
        this._blackGfx.alpha = 0;

        this._finallyIFoundIt = new PIXI.Sprite(GameResources.getTextures("finallyIFoundIt")[0]);
        this._finallyIFoundIt.visible = false;
        this._finallyIFoundIt.anchor.set(0.5);

        this._beerTime = new PIXI.spine.Spine(GameResources.getSpineAsset("beerTime"));
        this._beerTime.visible = false;

        this.createBeerTimeFire();
        this.createTotalWin();
    }

    protected startPresentation(data?: FITHParsedGameData, onShowComplete?: () => void): void {
        const isPlayedBigWin: boolean | undefined = (data && data.isEndBigWin),
            delay: number = isPlayedBigWin ? 1 : 0;

        // #131
        this._button.visible = false;

        // #212
        SlotGame.winFieldController.showWinField(data?.totalWin, undefined, true);

        TweenLite.delayedCall(delay, () => this.startPresentationAfterDelay(data, onShowComplete));
    }

    protected onResize(resizeData: IResizeData): void {
        super.onResize(resizeData);

        this.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);

        this._animation.position.set(NolimitApplication.screenBounds.width / 2, NolimitApplication.screenBounds.height / 2);
        this._container.position.set(NolimitApplication.screenBounds.width / 2, NolimitApplication.screenBounds.height / 2);
        this._finallyIFoundIt.position.set(NolimitApplication.screenBounds.width / 2, NolimitApplication.screenBounds.height / 2);
        this._beerTime.position.set(NolimitApplication.screenBounds.width / 2, NolimitApplication.screenBounds.height / 2);

        this.setTotalWinPosition();

        if (this._beerTimeFire.visible) {
            this.setFireProps();
        }
    }

    protected onResizeGameGraphics(resizeData: IResizeData): void {
        this._blackGfx.clear();
        this._blackGfx.beginFill(0x000000);
        this._blackGfx.drawRect(0, 0, this._screenWidth, this._screenHeight);
        this._blackGfx.endFill();
    }

    // #245
    protected setButtonPosition(data: IResizeData): void {
        super.setButtonPosition(data);

        if (NolimitApplication.isLandscape) {
            this._button.setSize(384, 102, 1);
        } else {
            this._button.setSize(307, 82, 0.8);
        }
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        this._container = new PIXI.Container();
        this._container.visible = false;

        this.createYouWonText();
        this.createPlayedBetMultiply();
        this.createTotalWinLabel();
        this.createSpinsPlayed();

        return this._container;
    }

    protected stopPresentation(closeCallback?: () => void): void {
        const timeline: TimelineLite = new TimelineLite();
        
        FITHGameModuleConfig.featurePrice.reset();
        
        if (!this._isBeerTimePlaying) {
            // #319
            FITHSoundManager.playContinueButton();

            timeline.add(this.fadeInBlack());
        }

        timeline.add(() => {
            this._animation.visible = false;
            this._animation.state.clearTracks();
            this._container.visible = false;
            this._button.visible = false;

            this._totalWin.visible = false;

            this._finallyIFoundIt.visible = false;
            this._beerTime.visible = false;
            this._beerTime.state.clearTracks();
            this._beerTimeFire.hide();
            this._beerTimeFire.stopLoop();

            // #308
            if (this._isBeerTimePlaying) {
                FITHSoundManager.playBeerTimeEnds();
                FITHSoundManager.switchBeerTimeToMain();
            }
        });
        timeline.add(() => FITHFreeSpinOutroView.actuallyDoTransition());
        timeline.add(() => this.restoreBaseGameReels());
        timeline.to(this, 1, {alpha: 0, ease: Linear.easeNone});
        timeline.add(() => {
            super.stopPresentation(closeCallback);
        });
    }

    private createBeerTimeFire(): void {
        this._beerTimeFire = new TimelineSprite(GameResources.getTextures("bigWinFire"));
        this._beerTimeFire.hide();
        this._beerTimeFire.anchor.set(0.5);
        this._beerTimeFire.blendMode = PIXI.BLEND_MODES.ADD;
        this._beerTimeFire.scale.x = 2;
    }

    private createTotalWin(): void {
        this._totalWin = new BitmapCountUp({
            style: {
                font: {
                    name: "NumbersWinCountUp",
                    size: 40
                },
                tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
            }
        });
        this._totalWin.visible = false;
        this._totalWin.maxTextWidth = 600;
    }

    private createYouWonText(): void {
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
                fill: "#fff",
                fontFamily: "Marion",
                fontSize: 36,
                fontWeight: FontWeight.BOLD
            }),
            youWon: PIXI.Text = new PIXI.Text(SlotGame.api.translations.translate("YOU WON"), textStyle);

        youWon.position.x = -5;
        youWon.position.y = -190;
        youWon.anchor.set(0.5);

        this._container.addChild(youWon);
        this._youWonLabel = youWon;
    }

    private createPlayedBetMultiply(): void {
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
            fill: "#ff7800",
            fontFamily: "Marion",
            fontSize: 50,
            fontWeight: FontWeight.BOLD
        });

        this._playedBetValueMultiply = new PIXI.Text("", textStyle);
        this._playedBetValueMultiply.anchor.set(0.5);
        this._playedBetValueMultiply.position.y = -110;

        this._container.addChild(this._playedBetValueMultiply);
    }

    // #243
    private createTotalWinLabel(): void {
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
            fill: "#ff7800",
            fontFamily: "Marion",
            fontSize: 40,
            fontWeight: FontWeight.BOLD
        });

        this._totalWinLabel = new PIXI.Text(SlotGame.api.translations.translate("TOTAL WIN"), textStyle);
        this._totalWinLabel.anchor.set(0.5);
        this._totalWinLabel.position.y = -40;

        this._container.addChild(this._totalWinLabel);
    }

    private createSpinsPlayed(): void {
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
                fill: "#ff7800",
                fontFamily: "Marion",
                fontSize: 34,
                fontWeight: FontWeight.BOLD
            }),
            spinsPlayedText: PIXI.Text = new PIXI.Text(SlotGame.api.translations.translate("Spins played"), textStyle),
            yOffset: number = 20;

        spinsPlayedText.position.y = 130;
        spinsPlayedText.anchor.set(0.5);

        this._spinsPlayedNumber = new PIXI.Text("", textStyle);
        this._spinsPlayedNumber.anchor.set(0.5);
        this._spinsPlayedNumber.position.y = (spinsPlayedText.position.y + spinsPlayedText.height / 2 + yOffset);

        this._container.addChild(spinsPlayedText, this._spinsPlayedNumber);
    }

    private startPresentationAfterDelay(data?: FITHParsedGameData, onShowComplete?: () => void): void {
        this._reelsEnteringBonus = data?.reelsEnteringFreespin;

        this.alpha = 1;
        this._blackGfx.alpha = 0;

        FITHGameModuleConfig.bonusGameSpinNWagonAnimations.beforeSpinStart(true);
        FITHGameModuleConfig.background.toggleFSOverlay(true, 0.4);

        super.startPresentation(data, onShowComplete);

        if (data?.brokeTheBank) {
            this.playBeerTime(data.totalWin);
        } else {
            this.playNormalOutro(data);
        }
    }

    // #164
    private playBeerTime(totalWin: number): void {
        const tl: TimelineLite = new TimelineLite(),
            blackGfxDuration: number = 1,
            fadeDuration: number = 15 / 30,
            countUpDuration: number = 7.25, // #308
            soundDuration: number = 3.396, // #308
            maxInStateDuration: number = this._beerTime.spineData.findAnimation("MaxIn").duration;

        this.addChild(this._blackGfx, this._finallyIFoundIt, this._beerTime, this._beerTimeFire, this._totalWin, this._button);

        this._isBeerTimePlaying = true;
        this.setTotalWinPosition();

        this._finallyIFoundIt.visible = true;
        this._finallyIFoundIt.alpha = 0;

        tl.add([
            this.fadeInBlack(),
            () => FITHSoundManager.fadeForBeerTime(0, 2000)
        ], 0);

        tl.to(this._finallyIFoundIt, fadeDuration, {alpha: 1}, blackGfxDuration);
        tl.to(this._finallyIFoundIt, fadeDuration, {alpha: 0}, blackGfxDuration + (2 * fadeDuration));

        tl.add(() => {
            this._beerTime.updateTransform();
            this._beerTime.visible = true;

            this._beerTime.state.clearTracks();
            this._beerTime.skeleton.setToSetupPose();
            this._beerTime.skeleton.setSlotsToSetupPose();
            this._beerTime.state.setEmptyAnimation(0, 0);

            this._beerTime.state.setAnimation(0, "In", false);
        }, blackGfxDuration + (3 * fadeDuration));

        tl.add(() => {
            this._beerTime.state.clearTracks();
            this._beerTime.state.setAnimation(0, "Drink", true);

            this._totalWin.visible = true;
            this._totalWin.alpha = 1;
            this._totalWin.getCountUpAnimation(0, totalWin, {duration: countUpDuration});

            this.setFireProps();
            this._beerTimeFire.show();
            this._beerTimeFire.playLoop();

            FITHSoundManager.playBeerTimeCountUp();
        }, soundDuration);

        tl.add(() => {
            this._beerTime.state.clearTracks();
            this._beerTime.state.setAnimation(0, "Out", false);

            TweenLite.to(this._totalWin.scale, 0.25, {x: 1.4, y: 1.4});
            TweenLite.to(this._totalWin.scale, 0.25, {x: 1, y: 1, delay: 0.25});
        }, (soundDuration + countUpDuration));

        tl.add(() => {
            FITHSoundManager.playBeerTimeCountUpEnds();

            FITHSoundManager.playBeerTimeMusic();
        }, (soundDuration + countUpDuration + 0.25));

        tl.to(this._totalWin, 0.5, {alpha: 0}, (soundDuration + countUpDuration + 1.5));
        tl.to(this._totalWin, 0.5, {y: this._totalWin.y - 200}, (soundDuration + countUpDuration + 1.5));

        tl.add(() => {
            this._beerTime.state.clearTracks();
            this._beerTime.state.setAnimation(0, "MaxIn", false);
        }, (soundDuration + countUpDuration + 2.5));

        tl.add(() => {
            this._beerTime.state.clearTracks();
            this._beerTime.state.setAnimation(0, "MaxLoop", true);

            this._button.visible = true;
        }, soundDuration + countUpDuration + 2.5 + maxInStateDuration);
    }

    private playNormalOutro(data?: FITHParsedGameData): void {
        data = data!;

        const isPlayedBigWin: boolean = data.isEndBigWin,
            totalWin: number = data.totalWin,
            // #353
            totalWinBelowStake: boolean = FITHGameModuleConfig.featurePrice.isWinBelowStake();

        this.addChild(this._totalWin, this._button, this._blackGfx);

        this._youWonLabel.visible = this._totalWinLabel.visible = !totalWinBelowStake;

        // #319, #353
        if (!totalWinBelowStake) {
            FITHSoundManager.playFSEnds();
        }

        this._animation.updateTransform();
        this._animation.visible = true;
        const spineTween: SpineTween = new SpineTween(this._animation, 0, "in");
        TweenLite.delayedCall(spineTween.totalDuration() / 2, () => {
            const countUpDuration: number = ((isPlayedBigWin || (totalWin === 0) || totalWinBelowStake) ? 0 : 1.5); // #353
            this._container.visible = true;

            this._isBeerTimePlaying = false;
            this.setTotalWinPosition();
            this._totalWin.visible = true;
            this._totalWin.alpha = 1;
            // #131
            if (isPlayedBigWin) {
                this._totalWin.text = (totalWin.toFixed(2));

                // so that the amount doesn't go out of screen.
                while (this._totalWin.textWidth * this._totalWin.scaling > 600) {
                    this._totalWin.fontSize--;
                    this._totalWin.dirty = true;
                    this._totalWin.updateTransform();
                }
                this._totalWin.pivot.set(this._totalWin.width / 2, this._totalWin.height / 2);
            } else {
                this._totalWin.getCountUpAnimation(0, totalWin, {duration: countUpDuration});

                // #319, #353
                if (countUpDuration) {
                    FITHSoundManager.playCountUp();
                }
            }
            this._playedBetValueMultiply.text = SlotGame.api.currency.format(data?.playedBetValue!) + " x " + data?.bonusWinTimesBetAfter;
            this._spinsPlayedNumber.text = data?.numberOfFreespinsPlayed!.toString() || "";

            TweenLite.delayedCall(countUpDuration, () => {
                this._button.visible = true;

                // #319, #353
                if (countUpDuration) {
                    FITHSoundManager.playFSEndsCountUpEnds();
                    FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.COUNT_UP);
                }
            });

            // #235
            FITHSoundManager.switchFStoMain();
        });
        TweenLite.delayedCall(spineTween.totalDuration(), () => {
            this._animation.state.clearTracks();
            this._animation.state.setAnimation(0, "base", true);
        });
    }

    private fadeInBlack(): TweenLite {
        return TweenLite.to(this._blackGfx, 1, {alpha: 1, ease: Linear.easeNone});
    }

    private restoreBaseGameReels(): void {
        const reels: string[][] = this._reelsEnteringBonus!;
        let sym: StateReelSymbol;
        for (let i: number = 0; i < reels.length; i++) {
            for (let j: number = 0; j < reels.length; j++) {
                sym = (Reels.getSymbol(i, j)!);
                sym.replaceWith(reels[i][j], i);
                if (sym.symName === "X") {
                    sym.setVisibility(false);
                }
            }
            (Reels.getReel(i) as FITHAvalancheReelController).reOrderSymbols();
        }
    }

    private setTotalWinPosition(): void {
        let yOffset: number = 40;

        if (this._isBeerTimePlaying) {
            yOffset = 200;
        }
        this._totalWin.position.set(NolimitApplication.screenBounds.width / 2, NolimitApplication.screenBounds.height / 2 + yOffset);
    }

    private setFireProps(): void {
        const yOffset: number = 140,
            heightCalculator: number = 0.65;

        this._beerTimeFire.x = (NolimitApplication.screenBounds.width / 2);
        this._beerTimeFire.y = (NolimitApplication.screenBounds.bottom - yOffset - NolimitApplication.screenBounds.top);
        this._beerTimeFire.height = (NolimitApplication.screenBounds.height * heightCalculator);
    }
}
